<template>
  <v-app class="container_tabledata" color="#fff">
    <v-card elevation="0">
      <v-layout v-resize="onResize" column style="">
        <loadingTable v-if="!fleetSummary" />
        <v-card v-if="fleetSummary" class="ma-3 elevation-0 rounded-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card class="pa-2" outlined tile>
             <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dense dark>
                Fleet Summary
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPage)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPage = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPage = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPage = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPage = fleetSummary.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
          
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="fleetSummary"
                  :search="search"
                  :headers="headersFleetSummary"
                  :items="fleetSummary"
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCount = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 10em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 20em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 20em"
                      >
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn  
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 23em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="page"
                    color="#A1BBD7"
                    :length="pageCount"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card class="pa-2" outlined tile>
              <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dense dark>
                Sailink
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPageSailink)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPageSailink = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageSailink = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageSailink = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageSailink = sailinkSummary.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
               
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="sailinkSummary"
                  :search="searchSailink"
                  :headers="headersSailink"
                  :items="sailinkSummary"
                  hide-default-footer
                  :page.sync="pageSailink"
                  :items-per-page="itemsPerPageSailink"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountSailink = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                         
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pageSailink"
                    color="#A1BBD7"
                    :length="pageCountSailink"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card class="pa-2" outlined tile>
                <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dark dense>
                Thuraya
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPageThuraya)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPageThuraya = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageThuraya = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageThuraya = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageThuraya = thurayaSummary.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
          
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="thurayaSummary"
                  :search="searchThuraya"
                  :headers="headersThuraya"
                  :items="thurayaSummary"
                  hide-default-footer
                  :page.sync="pageThuraya"
                  :items-per-page="itemsPerPageThuraya"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountThuraya = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                         
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pageThuraya"
                    color="#A1BBD7"
                    :length="pageCountThuraya"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col cols="3">
                <v-card class="pa-2" outlined tile>
              <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dense dark>
                Terminal List
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPageTerminal)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPageTerminal = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageTerminal = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageTerminal = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageTerminal = terminalList.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="terminalList"
                  :search="searchTerminal"
                  :headers="headersTerminal"
                  :items="terminalList"
                  hide-default-footer
                  :page.sync="pageTerminal"
                  :items-per-page="itemsPerPageTerminal"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountTerminal = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                        
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pageTerminal"
                    color="#A1BBD7"
                    :length="pageCountTerminal"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col cols="3">
                <v-card class="pa-2" outlined tile>
              <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dense dark>
                IP Phone List
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPagePhone)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPagePhone = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPagePhone = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPagePhone = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPagePhone = phoneList.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
                 
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="phoneList"
                  :search="searchPhone"
                  :headers="headersPhone"
                  :items="phoneList"
                  hide-default-footer
                  :page.sync="pagePhone"
                  :items-per-page="itemsPerPagePhone"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountPhone = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                        
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pagePhone"
                    color="#A1BBD7"
                    :length="pageCountPhone"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col cols="3">
                <v-card class="pa-2" outlined tile>
              <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dense dark>
                Thuraya Rateplan List
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPageRateplan)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPageRateplan = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageRateplan = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageRateplan = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageRateplan = rateplanList.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
               
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="rateplanList"
                  :search="searchRateplan"
                  :headers="headersRateplan"
                  :items="rateplanList"
                  hide-default-footer
                  :page.sync="pageRateplan"
                  :items-per-page="itemsPerPageRateplan"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountRateplan = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                        
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pageRateplan"
                    color="#A1BBD7"
                    :length="pageCountRateplan"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col cols="3">
                <v-card class="pa-2" outlined tile>
              <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dense dark>
               User List
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPageUser)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPageUser = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageUser = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageUser = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageUser = userList.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
               
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="userList"
                  :search="searchUser"
                  :headers="headersUser"
                  :items="userList"
                  hide-default-footer
                  :page.sync="pageUser"
                  :items-per-page="itemsPerPageUser"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountUser = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                        
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pageUser"
                    color="#A1BBD7"
                    :length="pageCountUser"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col>
                <v-card class="pa-2" outlined tile>
                <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dark dense>
                Company Group List
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPageGroup)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPageGroup = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageGroup = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageGroup = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageGroup = groupList.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
          
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="groupList"
                  :search="searchGroup"
                  :headers="headersGroup"
                  :items="groupList"
                  hide-default-footer
                  :page.sync="pageGroup"
                  :items-per-page="itemsPerPageGroup"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountGroup = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                       
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-right</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pageGroup"
                    color="#A1BBD7"
                    :length="pageCountGroup"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
            <v-col>
                <v-card class="pa-2" outlined tile>
                <v-toolbar class="elevation-0 rounded-0" color="#92B7DB" dark dense>
                Company List
              </v-toolbar>
                <v-toolbar
                  elevation="0"
                  class="pa-0"
                  color="#CCDBE3"
                  fixed
                  dense
                >
                  <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="rounded-0 pa-1 elevation-0 ma-0"
                        color="#ffff"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ kFormatter(itemsPerPageCompany)
                        }}<v-icon small style="margin-left: 0.2em"
                          >mdi-unfold-more-horizontal</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="itemsPerPageCompany = 5"
                        ><v-list-item-title>5</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageCompany = 10"
                        ><v-list-item-title>10</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageCompany = 15"
                        ><v-list-item-title>15</v-list-item-title></v-list-item
                      >
                      <v-list-item @click="itemsPerPageCompany = companyList.length"
                        ><v-list-item-title>All</v-list-item-title></v-list-item
                      >
                    </v-list>
                  </v-menu>
                  <v-spacer style="width: 70%"></v-spacer>
          
                </v-toolbar>
                <v-data-table
                  style="margin-top: 0px"
                  v-if="companyList"
                  :search="searchCompany"
                  :headers="headersCompany"
                  :items="companyList"
                  hide-default-footer
                  :page.sync="pageCompany"
                  :items-per-page="itemsPerPageCompany"
                  class="elevation-0 rounded-0 dataTable"
                  @page-count="pageCountCompany = $event"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 4em"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; min-width: 6em"
                      >
                        {{ row.item[0] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        {{ row.item[1] }}
                      </td>
                      <td class="pa-0" style="white-space: nowrap">
                        <v-btn
                         
                          color="primary"
                          dark
                          role="button"
                          class="pingbtn elevation-0 rounded-0"
                          style="min-width: 7em;cursor:not-allowed"
                          small
                          ><v-icon small>mdi-chevron-double-down</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <div class="pt-0" style="background-color: #edecff">
                  <v-pagination
                    v-model="pageCompany"
                    color="#A1BBD7"
                    :length="pageCountCompany"
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-progress-linear
            v-if="!listcrew && showcrewclick"
            indeterminate
            color="#0B4281"
            height="7"
            striped
          ></v-progress-linear>
        </v-card>
      </v-layout>
    </v-card>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loadingTable from "@/components/progress/loadingTable.vue";
export default {
  components: {
    loadingTable,
  },
  data() {
    return {
      search:'',
      itemsPerPage: 5,
      page: 1,
      pageCount: 0,
      headersFleetSummary: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchSailink:'',
      itemsPerPageSailink: 5,
      pageSailink: 1,
      pageCountSailink: 0,
      headersSailink: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchThuraya:'',
      itemsPerPageThuraya: 5,
      pageThuraya: 1,
      pageCountThuraya: 0,
      headersThuraya: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchTerminal:'',
      itemsPerPageTerminal: 5,
      pageTerminal: 1,
      pageCountTerminal: 0,
      headersTerminal: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchPhone:'',
      itemsPerPagePhone: 5,
      pagePhone: 1,
      pageCountPhone: 0,
      headersPhone: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchRateplan:'',
      itemsPerPageRateplan: 5,
      pageRateplan: 1,
      pageCountRateplan: 0,
      headersRateplan: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchUser:'',
      itemsPerPageUser: 5,
      pageUser: 1,
      pageCountUser: 0,
      headersUser: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchGroup:'',
      itemsPerPageGroup: 5,
      pageGroup: 1,
      pageCountGroup: 0,
      headersGroup: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
      searchCompany:'',
      itemsPerPageCompany: 5,
      pageCompany: 1,
      pageCountCompany: 0,
      headersCompany: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "Type", value: "type", width: "20%" },
        { text: "Amount", value: "amount", width: "50%" },
        { text: "", value: "", width: "50%" },
      ],
    };
  },

  created() {
    this.fetchSummary(localStorage.getItem("token"));
  },
  methods: {
    ...mapActions(["fetchSummary"]),

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },
  },

  computed: {
    ...mapGetters(["fleetSummary","sailinkSummary","thurayaSummary","terminalList","phoneList","rateplanList","userList","groupList","companyList"]),
  },
};
</script>

<style lang="scss" scoped></style>
